import { BlogPost } from "@models";
import { blogService } from "@services";
import { makeAutoObservable, runInAction } from "mobx";
import { BLOG_POSTS } from "../models/seo/blogPosts.js";

// Backend za blog ne postoji — članci su u models/seo/blogPosts.js (isti izvor koristi prerender).
const MOCK_POSTS: BlogPost[] = [...BLOG_POSTS].sort(
  (a, b) => b.publishedAt.localeCompare(a.publishedAt),
);

const USE_MOCK = true; // TODO: Set to false when backend Blog API is ready

export default class BlogStore {
  posts: BlogPost[] = [];
  post: BlogPost | undefined = undefined;
  totalCount = 0;
  skipCount = 0;
  maxResultCount = 9;
  loading = false;

  constructor() {
    makeAutoObservable(this);
  }

  getAll = async (tag?: string, categoryKey?: string) => {
    this.loading = true;
    if (USE_MOCK) {
      runInAction(() => {
        let filtered = MOCK_POSTS;
        if (tag) filtered = filtered.filter((p) => p.tags.includes(tag));
        if (categoryKey) filtered = filtered.filter((p) => p.categoryKey === categoryKey);
        this.posts = filtered;
        this.totalCount = filtered.length;
        this.loading = false;
      });
      return;
    }
    try {
      const response = await blogService.getAll({
        maxResultCount: this.maxResultCount,
        skipCount: this.skipCount,
        tag,
        categoryKey,
      });
      runInAction(() => {
        this.posts = this.skipCount === 0
          ? response.items
          : [...this.posts, ...response.items];
        this.totalCount = response.totalCount;
        this.loading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => { this.loading = false; });
    }
  };

  getBySlug = async (slug: string) => {
    this.loading = true;
    if (USE_MOCK) {
      runInAction(() => {
        this.post = MOCK_POSTS.find((p) => p.slug === slug);
        this.loading = false;
      });
      return;
    }
    try {
      const response = await blogService.getBySlug(slug);
      runInAction(() => {
        this.post = response;
        this.loading = false;
      });
    } catch (error) {
      console.error(error);
      runInAction(() => { this.loading = false; });
    }
  };

  loadMore = () => {
    this.skipCount += this.maxResultCount;
  };

  get hasMore() {
    return this.posts.length < this.totalCount;
  }

  clear = () => {
    this.posts = [];
    this.post = undefined;
    this.totalCount = 0;
    this.skipCount = 0;
  };
}
